import { AxiosInstance } from "axios"
import { ApiResponse } from "../../models/api"
import { Service } from "../../models/service"

export interface GetServicesParams {
    limit?: number
    page?: number
    paginate?: boolean
    teamId?: string
    teamIds?: string
}

export class ServicesApi {
    private client: AxiosInstance

    constructor(client: AxiosInstance) {
        this.client = client
    }

    getServices = (params?: GetServicesParams) =>
        this.client.get<ApiResponse<Service>>("services", {
            params: {
                limit: params?.limit ?? 20,
                page: params?.page ?? 1,
                paginate: params?.paginate ?? true,
                teamId: params?.teamId ?? "",
                teamIds: params?.teamIds ?? "",
            },
        })
}
